import * as icon from "services/icon";
import { get_gg_reward_by_user } from "api/api";

export const FETCH_WALLET_REQUEST = "FETCH_WALLET_REQUEST";
export const FETCH_WALLET_RECEIVED = "FETCH_WALLET_RECEIVED";
export const FETCH_WALLET_FAIL = "FETCH_WALLET_FAIL";

export const FETCH_WALLET_SUCCESS = "FETCH_WALLET_SUCCESS";
export const WALLET_ADDRESS_REMOVE = "WALLET_ADDRESS_REMOVE";
export const FETCH_WALLET_CONNECTION_TYPE = "FETCH_WALLET_CONNECTION_TYPE";
export const FETCH_WALLET_PATH = "FETCH_WALLET_PATH";
export const FETCH_WALLET_PATH_ERROR = "FETCH_WALLET_PATH_ERROR";
export const FETCH_WALLET_TRANSPORT = "FETCH_WALLET_TRANSPORT";

export const DETECT_MARKET_PLACE_REQUEST = "DETECT_MARKET_PLACE_REQUEST";
export const DETECT_MARKET_PLACE_APPROVED = "DETECT_MARKET_PLACE_APPROVED";
export const DETECT_MARKET_PLACE_DENIED = "DETECT_MARKET_PLACE_DENIED";

export const removeWalletAddress = () => {
  return {
    type: WALLET_ADDRESS_REMOVE,
  };
};

export const fetchWalletError = (error) => {
  return {
    type: FETCH_WALLET_FAIL,
    error: error,
  };
};

const fetchSuccess = (address) => {
  return {
    type: FETCH_WALLET_SUCCESS,
    walletAddress: address,
  };
};

const fetchWalletType = (type) => {
  return {
    type: FETCH_WALLET_CONNECTION_TYPE,
    connectionType: type,
  };
};

const fetchWalletPathSuccess = (path) => {
  return {
    type: FETCH_WALLET_PATH,
    path: path,
  };
};

const fetchWalletPathError = (error) => {
  return {
    type: FETCH_WALLET_PATH,
    error: error,
  };
};

export const fetchWalletTransport = (transport) => {
  return {
    type: FETCH_WALLET_TRANSPORT,
    transport: transport,
  };
};

export const fetchWalletSuccess = (address, type) => {
  return async (dispatch) => {
    try {
      dispatch(fetchSuccess(address));
      dispatch(fetchWalletType(type));
    } catch (error) {
      dispatch(fetchWalletError(error));
    }
  };
};

export const fetchWalletPath = (path, transport) => {
  return async (dispatch) => {
    try {
      dispatch(fetchWalletPathSuccess(path));
      dispatch(fetchWalletTransport(transport));
    } catch (error) {
      dispatch(fetchWalletPathError(error));
    }
  };
};

export const fetchWalletRecieved = (data) => {
  return {
    type: FETCH_WALLET_RECEIVED,
    data: data,
  };
};

export const detectMarketPlaceApproved = (approved) => {
  return {
    type: DETECT_MARKET_PLACE_APPROVED,
    approved: approved,
  };
};

const detectMarketError = (error) => {
  return {
    type: DETECT_MARKET_PLACE_DENIED,
    error: error,
  };
};

export const detectMarketPlace = (address) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DETECT_MARKET_PLACE_REQUEST });

      const nftOwned = await icon._getOwnedNft(address);

      if (nftOwned.nftList.length > 0) {
        const response = await icon.checkIfMarketPlaceIsApproved(address);

        dispatch(detectMarketPlaceApproved(response));
      }
    } catch (error) {
      dispatch(detectMarketError(error));
    }
  };
};

export const FETCH_GG_REWARD_PENDING = "FETCH_GG_REWARD_PENDING";
export const FETCH_GG_REWARD_FAIL = "FETCH_GG_REWARD_FAIL";
export const FETCH_GG_REWARD_FULFILLED = "FETCH_GG_REWARD_FULFILLED";
export const fetch_gg_reward_start = () => {
  return {
    type: FETCH_GG_REWARD_PENDING,
  };
};
export const fetch_gg_reward_success = (response) => {
  return {
    type: FETCH_GG_REWARD_FULFILLED,
    data: response,
  };
};

export const fetch_gg_reward_fail = (error) => {
  return {
    type: FETCH_GG_REWARD_FAIL,
    error: error,
  };
};

export const fetch_gg_reward_by_user = (address) => {
  console.log("fetching gg_reward:", address);
  return async (dispatch) => {
    dispatch(fetch_gg_reward_start());
    get_gg_reward_by_user(address)
      .then((response) => {
        dispatch(fetch_gg_reward_success(response.data));
      })
      .catch((error) => {
        dispatch(fetch_gg_reward_fail(error));
      });
  };
};

export const SET_CLAIM_TIMER_PENDING = "SET_CLAIM_TIMER_PENDING";
export const SET_CLAIM_TIMER_FAIL = "SET_CLAIM_TIMER_FAIL";
export const SET_CLAIM_TIMER_FULFILLED = "SET_CLAIM_TIMER_FULFILLED";
export const set_claim_timer_start = () => {
  return {
    type: SET_CLAIM_TIMER_PENDING,
  };
};
export const set_claim_timer_success = (response) => {
  return {
    type: SET_CLAIM_TIMER_FULFILLED,
    data: response,
  };
};

export const set_claim_timer_fail = (error) => {
  return {
    type: SET_CLAIM_TIMER_FAIL,
    error: error,
  };
};

export const set_claim_timer = (data) => {
  return async (dispatch) => {
    try {
      dispatch(set_claim_timer_start());
      dispatch(set_claim_timer_success(data));
    } catch (error) {
      dispatch(set_claim_timer_fail(error));
    }
  };
};
